import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignSelf: 'flex-start',
    background: theme.palette.custom.background.area,
    boxShadow: theme.shadows[25],
    margin: `${theme.spacing(3)}px auto`,
    maxWidth: theme.spacing(80),
    overflow: 'hidden',
    maxHeight: `calc(100% - ${theme.spacing(6)})`,

    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(3, 0),
    },

    '& .informations': {
      '&-header': {
        display: 'flex',
        alignItems: 'center',
        height: theme.spacing(21 / 2),
        minHeight: theme.spacing(21 / 2),
        padding: theme.spacing(0, 3),
        color: theme.palette.text.secondary,
      },
      '&-body': {
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3),
        flexGrow: 1,
      },
      '&-input': {
        marginBottom: theme.spacing(3),
      },
      '&-textarea': {
        marginBottom: theme.spacing(3),
        minHeight: theme.spacing(12),
      },
      '&-footer': {
        display: 'flex',
        alignItems: 'center',
        height: theme.spacing(8),
        minHeight: theme.spacing(8),
        padding: theme.spacing(0, 2),
        borderTop: `solid 1px ${theme.palette.divider}`,
      },
      '&-btn-next': {
        marginLeft: 'auto',
      },
    },
  },
  input: {
    minHeight: theme.spacing(10),
    alignItems: 'flex-start',
  },
}));

export default styles;
